import { DEFAULT } from '../constants/defaults';
import { QUALIFICATIONS_CATEGORIES } from '../constants/qualification-categories';
import { AidaPayload } from '../interfaces/aida.interface';

export class AidaSurveyQuotasEditInspector<
  T extends { buyer_quota_id?: string }
> {
  constructor(
    private _aida: AidaPayload,
    private _quotas: T[] = [],
    private _qualificatonHasNestedQuotas = false,
    private _scenario: 'apply-nesting' | 'clear-nesting' | 'other' = 'other'
  ) {}

  get quotas(): T[] {
    return this._quotas || [];
  }

  get aida(): AidaPayload {
    return this._aida || DEFAULT.AIDA_PAYLOAD;
  }

  public notEditable(): boolean {
    return !this._editable();
  }

  private _editable(): boolean {
    if (!this.aida.enabled) {
      return true;
    }

    if (!this.aida.selected_quota_ids?.length) {
      return true;
    }

    return this._scenario === 'other'
      ? this._otherEditable()
      : this._nestingEditable();
  }

  private _otherEditable(): boolean {
    if (
      this._aida.category === QUALIFICATIONS_CATEGORIES.NESTED &&
      this._qualificatonHasNestedQuotas
    ) {
      return false;
    }
    return !this.quotas.some((q) =>
      this.aida.selected_quota_ids!.includes(q.buyer_quota_id || '')
    );
  }

  private _nestingEditable(): boolean {
    if (this._aida.category === QUALIFICATIONS_CATEGORIES.NESTED) {
      // In apply-nesting scenario we have to allow allocation changing, but not other operations resulting in quota ID changes
      return this._scenario === 'apply-nesting'
        ? this.quotas.every((q) =>
            this.aida.selected_quota_ids!.includes(q.buyer_quota_id || '')
          )
        : false;
    }
    return true;
  }
}
